module.exports = __webpack_public_path__ + "img/covid-vaccine.52f59fe6.svg";